<template>
  <div class="micro-elements">
    <container>
      <template v-slot:header>
        {{$ml.get(`MICROELEMENT CONTENT, %`)}}
      </template>
      <div class="content">
        <div v-for="(value, key, i) in data" :key="i">
          <span>
            {{ key }}
          </span>
          <span>
            {{ value }}
            <!-- <span class="unit">
              %
            </span> -->
          </span>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
import Container from "@/components/common/HeadedContainer"

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Container
  }
}
</script>

<style lang="scss" scoped>
  .micro-elements {
    .content {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      padding: 25px 35px;
      box-sizing: border-box;
      flex-direction: column;

      div {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 20px 200px 20px 10px;
        border-top: solid 1px rgba(76, 80, 86, 0.1);
        border-bottom: solid 1px rgba(76, 80, 86, 0.1);

        span {
          font-size: 16px;
          font-weight: 400;

          .unit {
            color: $mainGreen;
          }
        }

        @media (max-width: 500px) {
          padding: 20px 10px 20px 10px;
        }
      }
    }
  }
</style>
